import { ClassNames, css } from '@emotion/react';
import React from 'react';

export type LinkButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const LinkButton: React.FC<LinkButtonProps> = ({ className, ...props }) => {
  return (
    <ClassNames>
      {({ cx }) => (
        <button
          className={cx(className, 'focus-visible-outline')}
          css={styles.button}
          type="button"
          {...props}
        />
      )}
    </ClassNames>
  );
};

const styles = {
  button: css({
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'inherit',
    outline: 'none',
    padding: '0',
  }),
};
